var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"md:flex justify-end"}),_c('CommonDataTable',{staticClass:"mt-4",attrs:{"keySearch":_vm.keySearch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }